import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}
	navcheck = (e) => {
		var valid = false
		if (this.props.data.PAList.length == 0) {
			this.props.navigate('F2')
		} else {
			this.props.navigate('F3')
		}
	}
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>We have reviewed all current authorizations for this member.</p>
				<p>The total number of calories per day currently authorized for this member is {this.props.data.TotalCaloriesPerDay}.</p>
				<p>The total number of caloric units per month currently authorized for this patient is  {this.props.data.TotalCaloriesPerMonth}.</p>

				<div className="button" onClick={() => this.navcheck()}>Continue</div>
			</div>
		);
	}
}